import React, { Fragment } from 'react'
import Description from './desctiption/Description'

interface RulesProps {
  content: any[]
  colors?: any
}
export default function Rules({ content }: RulesProps) {
  return (
    <Fragment>
      {content.map((s, i) => (
        <Description
          title={s.title}
          description={s.description}
          icon={s.icon}
          background={s.background}
          width={s.width}
          height={s.height}
          textColor={s.textColor}
          borderColor={s.borderColor}
          size={s.size}
          key={i}
        />
      ))}
    </Fragment>
  )
}
